import React, { Component } from 'react'
import { FormControl, MenuItem, ListItemText } from '@material-ui/core'
import PropType from 'prop-types'
import cn from 'classnames'
import { injectIntl } from 'react-intl'
import { CheckBox, CheckBoxOutlineBlank } from '@material-ui/icons'
import { Select } from 'components/common/FormInputs'

class FinalFormMultipleSelect extends Component {
  renderChildrenItems = () => {
    const {
      data,
      intl: { formatMessage },
    } = this.props

    if (data && data.length > 0) {
      return data.map(item => {
        const itemText =
          typeof item === 'string' && item.includes('_')
            ? formatMessage({ id: item })
            : item.name

        return (
          <MenuItem
            key={`key_${item.id || item}`}
            value={item}
            className="multiselect-item">
            {this.showItemIcon(item)}
            <ListItemText primary={itemText} />
          </MenuItem>
        )
      })
    }
  }

  showItemIcon = item => {
    const {
      input: { value },
    } = this.props
    const foundValue =
      value.length &&
      value.find(
        valueItem =>
          valueItem === item ||
          (valueItem.id && item.id && valueItem.id === item.id),
      )

    return foundValue ? (
      <CheckBox className="checked" />
    ) : (
      <CheckBoxOutlineBlank className="unchecked" />
    )
  }

  renderValues = () => {
    const {
      input: { value },
      intl: { formatMessage },
    } = this.props

    if (Array.isArray(value) && value.length > 0) {
      return value
        .map(item =>
          typeof item === 'string' && item.includes('_')
            ? formatMessage({ id: item })
            : item.name,
        )
        .join(', ')
    }

    return []
  }

  render() {
    const {
      name,
      label,
      disabled,
      children,
      formControlProps,
      customValuesRender,
      autoWidth,
      meta,
      input,
      data,
      className,
    } = this.props
    const valueRenderMethod = () =>
      customValuesRender ? customValuesRender(input.value) : this.renderValues()

    return (
      <FormControl
        fullWidth
        component="div"
        className={cn('multiselect-control', className)}>
        <Select
          multiple
          id={name}
          name={name}
          label={label}
          meta={meta}
          input={input}
          formControlProps={formControlProps}
          disabled={disabled || data.length === 0}
          autoWidth={autoWidth}
          MenuProps={{
            className: 'multiselect-menu',
            getContentAnchorEl: null,
          }}
          renderValue={valueRenderMethod}>
          {children || this.renderChildrenItems()}
        </Select>
      </FormControl>
    )
  }
}

FinalFormMultipleSelect.defaultProps = {
  input: PropType.shape({
    value: PropType.array,
  }),
  formControlProps: PropType.object,
}

export default injectIntl(FinalFormMultipleSelect)
